import TopTicker from './components/TopTicker';
import SiteNav from './components/SiteNav';
import Hero from './components/Hero';
import TodayUpdates from './components/TodayUpdates';
import HotRanking from './components/HotRanking';
import NewReleases from './components/NewReleases';
import TheaterSync from './components/TheaterSync';
import HighRated from './components/HighRated';
import GenreExplorer from './components/GenreExplorer';
import GuideSection from './components/GuideSection';
import FaqSection from './components/FaqSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <TopTicker />
      <SiteNav />
      <main className="w-full">
        <Hero />
        <TodayUpdates />
        <HotRanking />
        <NewReleases />
        <TheaterSync />
        <HighRated />
        <GenreExplorer />
        <GuideSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}